import utils from "../utils/utils";
import BTCValidator from "./bitcoin_validator";
import ETHValidator from "./ethereum_validator";
import BCHValidator from "./bitcoincash_validator";
import LTCValidator from "./ltc_validator";
import BNBValidator from "./bnb_validator";
import TERRAValidator from "./terra_validator";

const ALLOWED_CHARS = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
const regexp = new RegExp(`^(thor)1([${ALLOWED_CHARS}]+)$`); // thor + bech32 separated by '1'

export default {
  isValidThorAddress(address) {
    const match = regexp.exec(address);
    if (match !== null) {
      return this.verifyChecksum(address);
    }
    return false;
  },

  verifyChecksum(address) {
    const decoded = utils.bech32.decode(address);
    if (decoded !== null) {
      return decoded.data.length === 32;
    }
    return false;
  },

  isValidAddress(address) {
    return (
      this.isValidThorAddress(address) ||
      BTCValidator.isValidAddress(address, {
        name: "Bitcoin",
        symbol: "btc",
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
      }) ||
      ETHValidator.isValidAddress(address, {
        name: "Ethereum",
        symbol: "eth",
      }) ||
      BCHValidator.isValidAddress(
        address,
        {
          name: "BitcoinCash",
          symbol: "bch",
          addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        },
        "prod",
        ["all"]
      ) ||
      LTCValidator.isValidAddress(address, {
        name: "LiteCoin",
        symbol: "ltc",
        addressTypes: { prod: ["30", "05", "32"], testnet: ["6f", "c4", "3a"] },
      }) ||
      BNBValidator.isValidAddress(address, {
        name: "Binance Coin",
        symbol: "bnb", // bep
      }) ||
      BTCValidator.isValidAddress(address, {
        name: "DogeCoin",
        symbol: "doge",
        addressTypes: { prod: ["1e", "16"], testnet: ["71", "c4"] },
      }) ||
      TERRAValidator.isValidAddress(address, {
        name: "Terra",
        symbol: "luna",
      })
    );
  },
};
